import { UPDT_CUR_RESP } from "../types";

export const updtCurResp = (id, value = []) => ({
  type: UPDT_CUR_RESP,
  payload: { qid: id, values: value },
});
